<template lang="pug">
v-container(fluid)
  v-row
    v-col
      v-text-field(
        v-model="portal.name",
        label="Portal Name",
      )
    v-col
      v-select(
        :items="$store.state.schema",
        item-text="name",
        item-value="name",
        v-model="portal.entity"
      )
  template(v-if="portal.name && portal.entity")
    app-entity-full-form(
      :iinstance="{}",
      :entity.sync="portal",
      editMode,
    )
    v-row(justify="end")
      v-btn.primary(@click="save") Save
  //- pre {{ portal }}
</template>

<script>
import { AppEntityFullForm } from '@@/components'
import axios from 'axios'

export default {
  name: 'entity-add',
  data: () => ({
    portal: {
      name: null,
      fields: [],
      entity: null
    },
    t: `
      {
        "name": "Foo",
        "fields": [
          {
            "name": "foo",
            "type": "String",
            "primitive": true
          }
        ]
      }`,
  }),

  computed: {
    id () {
      return this.$route.params.item
    },
    tt () {
      try {
        return JSON.parse(this.t)
      } catch { return {name: '', fields: []} }
    }
  },


  methods: {
    async save () {
      if (this.id) {
        try {
          var response = await axios.put('portals/' + this.id,  { ...this.portal, _fields: JSON.stringify(this.portal.fields) })
        } catch {
          alert("Error")
        }
      } else {
        try {
          var response = await axios.post('portals',  { ...this.portal, _fields: JSON.stringify(this.portal.fields) })
        } catch {
          alert("Error")
        }
      }

    }
  },
  async mounted () {
    if (this.$route.params.item)
      this.portal = (await axios.get(`portals/${this.id}`)).data
  },
  components: {
    AppEntityFullForm,
  }
}
</script>
